import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 300px;

  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  > img {
    // object-fit: cover;
    width: 100%;
    height: 216px;
    border-radius: 10px 10px 0 0;
  }

  > div {
    padding: 20px;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    > ul {
      font-family: 'Montserrat';
      font-size: 1.2rem;
      color: #3c3c3c;
      list-style: none;

      img {
        height: 30px;
        margin-right: 10px;
      }

      li:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }
  }

  @media (max-width: 1220px) {
    margin: 20px auto;
  }
`;

export const NameLatestPodcastSerie = styled.span`
  font-family: 'Montserrat';
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.25rem;
  color: #fff;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  width: 100%;
`;
